/**
 * RemoteEntry — "Connect to a room". Ring motif + heading + the segmented
 * code field the phone/iPad types the TV's rotating share key into. Pure
 * presentation; `onConnect` calls RemoteApp's existing `doPair`.
 */

import { RingMotif } from '../ui/Clock.js';
import { QrCode } from '../ui/icons.js';
import { Button, CodeInput, Dot, Logo, StatusLine } from '../ui/components.js';

export function RemoteEntry(props: {
    status: string;
    tone: 'info' | 'err';
    keyInput: string;
    pairing: boolean;
    onChange: (value: string) => void;
    onConnect: () => void;
}): JSX.Element {
    return (
        <div className = "rm-entry">
            <RingMotif className = "rm-entry__rings" />
            <div className = "rm-entry__inner stack">
                <div className = "row">
                    <Logo />
                    <span className = "eyebrow">Remote</span>
                </div>
                <h1>Connect to a room</h1>
                <p className = "rm-entry__sub">
                    Enter the 6-character code shown on the room&rsquo;s display, or scan its QR.
                </p>
                <CodeInput
                    value = { props.keyInput }
                    length = { 6 }
                    onChange = { props.onChange }
                    onEnter = { props.onConnect }
                    autoFocus = { true }
                    testId = "rm-key-input" />
                <div className = "row" style = {{ marginTop: '1cqw' }}>
                    <Button
                        label = { props.pairing ? 'Connecting…' : 'Connect' }
                        disabled = { props.pairing }
                        onClick = { props.onConnect }
                        testId = "rm-connect" />
                    <span className = "linkbtn" style = {{ cursor: 'default' }}>
                        <QrCode /> Scan the QR on the TV instead
                    </span>
                </div>
                <StatusLine tone = { props.tone } text = { props.status } />
                <div className = "row muted" style = {{ fontSize: '1.3cqw', gap: '0.6cqw' }}>
                    <Dot kind = { props.tone === 'err' ? 'idle' : 'blue' } /> Find this code on the room&rsquo;s display
                </div>
            </div>
        </div>
    );
}
